import request from './request'
import { isCouponApiSuccess } from './couponApi'
import { getMockCouponUpdateAvailabilityResponse, shouldUseCouponMock } from './couponCenterMock'
import type { CouponDetailData } from './CouponDetai'

export interface ApiResponse<T = unknown> {
  code: number
  data: T
  msg: string
}

export type CouponStatusAction = 'deactivate' | 'reactivate'
export type CouponAvailabilityValue = 'active' | 'inactive'

export interface CouponSetStatusParams {
  id: number
  coupon_id: string
  action: CouponStatusAction
}

export type CouponSetStatusData = CouponDetailData

export function isCouponSetStatusSuccess(code: unknown): boolean {
  return isCouponApiSuccess(code)
}

export function mapAvailabilityForApi(action: CouponStatusAction): CouponAvailabilityValue {
  return action === 'reactivate' ? 'active' : 'inactive'
}

export function mapAvailabilityFromApi(value?: string): CouponAvailabilityValue {
  return (value ?? '').trim().toLowerCase() === 'active' ? 'active' : 'inactive'
}

function buildRequestBody(params: CouponSetStatusParams): Record<string, unknown> {
  return {
    id: params.id,
    availability: mapAvailabilityForApi(params.action),
  }
}

/** POST `/api/admin/coupon/update-availability` */
export async function postCouponSetStatus(
  params: CouponSetStatusParams,
): Promise<ApiResponse<CouponSetStatusData>> {
  if (shouldUseCouponMock()) {
    return getMockCouponUpdateAvailabilityResponse(params) as ApiResponse<CouponSetStatusData>
  }

  return request.post<ApiResponse<CouponSetStatusData>>(
    '/api/admin/coupon/update-availability',
    buildRequestBody(params),
  )
}
